<template>
  <div
    class="basic-layout d-flex align-items-center justify-content-center m-0 default-body"
    :class="isEbipac ? 'theme-ebipac' : 'theme-hka'"
  >
    <child />
    <notifications />
  </div>
</template>

<script>
import Child from '@/components/Child';
import Notifications from '~/components/Notifications';

export default {
  name: 'AuthLayout',
  components: {
    Child,
    Notifications,
  },
  computed: {
    isEbipac() {
      const env = process.env.VUE_APP_ENV;
      return env === 'EBI' || env === 'ebipac';
    },
  },
  mounted() {
    // Add a response interceptor
    window.axios.interceptors.response.use((response) => {
      if (!!response.data.type && !!response.data.message) {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
      }
      return response;
    }, (error) => {
      let errores = '';
      if (error.response.data.errors) {
        // Request made and server responded
        const errors = Object.values(error.response.data.errors);
        errors.forEach((element) => {
          errores += element;
        });
      } else if (error.request) {
        // The request was made but no response was received
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      } else {
        // Something happened in setting up the request that triggered an Error
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      }
      this.$store.dispatch('notifications/show', {
        message: errores,
        type: 'error',
      });
      return Promise.reject(error);
    });
  },
};
</script>

<style lang="scss">
@import "../../public/sass/app.scss";
</style>
<style scoped>
.default-body {
  overflow: hidden;
  position: relative;
  background-attachment: fixed;
}

.default-body::before {
  content: '';
  position: absolute;
  inset: -25%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.18), transparent 60%);
  opacity: 0.6;
  pointer-events: none;
}

.theme-hka {
  background:
    radial-gradient(circle at 18% 22%, rgba(116, 209, 234, 0.45), transparent 55%),
    radial-gradient(circle at 85% 80%, rgba(0, 78, 130, 0.55), transparent 50%),
    linear-gradient(135deg, #004e82 0%, #0084ca 52%, #59c3e8 100%) !important;
}

.theme-ebipac {
  background:
    radial-gradient(circle at 85% 15%, rgba(247, 148, 29, 0.30), transparent 55%),
    radial-gradient(circle at 12% 88%, rgba(26, 79, 160, 0.22), transparent 55%),
    linear-gradient(135deg, #f7fbff 0%, #e4f0ff 48%, #ffe9d2 100%) !important;
}
</style>
